import { render, staticRenderFns } from "./create-reporters.component.html?vue&type=template&id=37a6e5dc&scoped=true&external"
import script from "./create-reporters.component.ts?vue&type=script&lang=ts&external"
export * from "./create-reporters.component.ts?vue&type=script&lang=ts&external"
import style0 from "./create-reporters.component.scss?vue&type=style&index=0&id=37a6e5dc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a6e5dc",
  null
  
)

export default component.exports